import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-step-time-place',
  templateUrl: './step-time-place.component.html',
  styleUrls: ['./step-time-place.component.scss'],
})
export class StepTimePlaceComponent implements OnInit {
  @Input() timePlaceForm!: FormGroup;

  date: string = '';
  time: string = '';

  ngOnInit(): void {
    // Initialize with current date and time
    const now = new Date();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const year = now.getFullYear();
    this.date = `${month}/${day}/${year}`;

    let hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // convert 0 to 12 for 12-hour format
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    this.time = `${hours}:${formattedMinutes} ${ampm}`;

    // Update form values
    this.updateDate(this.date);
    this.updateTime(this.time);
  }

  updateTime(time: string): void {
    this.timePlaceForm.get('time')?.setValue(time);
  }

  updateDate(date: string): void {
    this.timePlaceForm.get('date')?.setValue(date);
  }
}
